export const findUserMarket = (markets, queues, userId) =>
	markets.find(
		(market) =>
			market._id ===
			queues.find((queue) => queue.consultants.includes(userId))?.market,
	);
